<template>
  <div class="p-4">
    <!-- Кнопка "Добавить цех" -->
    <button
      v-can-write="'workshops'"
      @click="openAddWorkshopModal"
      class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
    >
      Добавить цех
    </button>

    <!-- Состояние загрузки -->
    <div v-if="loading" class="flex justify-center items-center h-40">
      <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
    </div>

    <!-- Таблица цехов -->
    <table v-else class="w-full border-collapse bg-white shadow-md">
      <thead class="bg-gray-100">
        <tr>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">#</th>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Название цеха</th>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Действия</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(workshop, index) in workshops" :key="workshop.id" class="border-b hover:bg-gray-50">
          <td class="px-4 py-2 text-sm text-gray-700">{{ index + 1 }}</td>
          <td class="px-4 py-2 text-sm text-gray-700">{{ workshop.name }}</td>
          <td class="px-4 py-2">
            <button
              v-can-write="'workshops'"
              @click="confirmDelete(workshop.id)"
              class="px-2 py-1 text-sm font-medium text-red-600 bg-red-100 rounded-md hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500"
            >
              Удалить
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Модальное окно для добавления цеха -->
    <div v-if="addWorkshopModalVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
        <h2 class="text-lg font-bold mb-4">{{ isEditMode ? 'Редактировать цех' : 'Добавить цех' }}</h2>
        <form @submit.prevent="saveWorkshop">
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700 mb-1">Название цеха</label>
            <input
              type="text"
              v-model="newWorkshop.name"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Введите название цеха"
              required
            />
          </div>
          <div class="flex justify-end space-x-2">
            <button
              type="button"
              @click="closeAddWorkshopModal"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              Отмена
            </button>
            <button
              type="submit"
              class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {{ isEditMode ? 'Сохранить' : 'Добавить' }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Модальное окно подтверждения удаления -->
    <div v-if="isConfirmModalVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
        <h2 class="text-lg font-bold mb-4">Подтвердите удаление</h2>
        <p class="text-sm text-gray-700 mb-4">Вы уверены, что хотите удалить этот цех?</p>
        <div class="flex justify-end space-x-2">
          <button
            @click="cancelDelete"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            Отмена
          </button>
          <button
            @click="proceedDelete"
            class="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
          >
            Удалить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      workshops: [], // Список цехов
      loading: true, // Флаг загрузки
      addWorkshopModalVisible: false, // Флаг видимости модального окна добавления/редактирования
      isEditMode: false, // Флаг режима редактирования
      newWorkshop: {
        id: null, // ID редактируемого цеха (если есть)
        name: '', // Название цеха
      },
      isConfirmModalVisible: false, // Флаг видимости модального окна подтверждения
      workshopIdToDelete: null, // ID цеха для удаления
    };
  },
  created() {
    this.getWorkshops();
  },
  methods: {
    /**
     * Загружает список цехов.
     */
    getWorkshops() {
      axios
        .post('/api/workshop/getWorkshops', { module_id: this.$route.params.id })
        .then((response) => {
          this.workshops = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.error('Ошибка при загрузке цехов:', error);
          alert('Не удалось загрузить цеха. Попробуйте позже.');
          this.loading = false;
        });
    },

    /**
     * Показывает модальное окно добавления цеха.
     */
    openAddWorkshopModal() {
      this.isEditMode = false; // Режим создания
      this.newWorkshop = { id: null, name: '' }; // Очищаем данные
      this.addWorkshopModalVisible = true;
    },

    /**
     * Показывает модальное окно редактирования цеха.
     */
    openEditWorkshopModal(workshop) {
      this.isEditMode = true; // Режим редактирования
      this.newWorkshop = { ...workshop }; // Копируем данные цеха
      this.addWorkshopModalVisible = true;
    },

    /**
     * Сохраняет или обновляет цех.
     */
    saveWorkshop() {
      if (!this.newWorkshop.name) {
        alert('Название цеха не может быть пустым');
        return;
      }

      const url = this.isEditMode
        ? '/api/workshop/createOrUpdateWorkshop'
        : '/api/workshop/createOrUpdateWorkshop';

      axios
        .post(url, this.newWorkshop)
        .then(() => {
          this.getWorkshops(); // Обновляем список цехов
          this.closeAddWorkshopModal(); // Закрываем модальное окно
        })
        .catch((error) => {
          console.error('Ошибка при сохранении цеха:', error);
          alert('Не удалось сохранить цех. Попробуйте позже.');
        });
    },

    /**
     * Закрывает модальное окно добавления/редактирования.
     */
    closeAddWorkshopModal() {
      this.addWorkshopModalVisible = false;
      this.newWorkshop = { id: null, name: '' }; // Очищаем данные
    },

    /**
     * Подтверждает удаление цеха.
     */
    confirmDelete(id) {
      this.workshopIdToDelete = id;
      this.isConfirmModalVisible = true;
    },

    /**
     * Отменяет удаление цеха.
     */
    cancelDelete() {
      this.isConfirmModalVisible = false;
      this.workshopIdToDelete = null;
    },

    /**
     * Удаляет цех.
     */
    proceedDelete() {
      if (!this.workshopIdToDelete) {
        console.error('ID цеха не указан');
        return;
      }

      axios
        .post('/api/workshop/deleteWorkshop', { id: this.workshopIdToDelete })
        .then(() => {
          this.getWorkshops(); // Обновляем список цехов
          this.cancelDelete(); // Закрываем модальное окно
        })
        .catch((error) => {
          console.error('Ошибка при удалении цеха:', error);
          alert('Не удалось удалить цех. Попробуйте позже.');
        });
    },
  },
};
</script>
